/**
 * @file index.tsx
 * @module app/modules/dashboard
 * @description Defines the dashboard route and page metadata.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_admin/layout/core';
import SellingProducts from './selling-products';
import AdminDashboard from './admin-dashboard';
import TopSellers from './top-sellers';
import TopProducts from './top-products';
import TopCustomers from './top-customers';

const dashboardBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const DashboardIndex = () => (
  <>
    <Routes>
      <Route element={<Outlet />}>
        <Route
          index
          element={
            <>
              <PageTitle>Dashboard</PageTitle>
              <AdminDashboard />
            </>
          }
        />
        <Route
          path="/selling-products"
          element={
            <>
              <PageTitle breadcrumbs={dashboardBreadcrumbs}>
                Selling Products
              </PageTitle>
              <SellingProducts />
            </>
          }
        />
        <Route
          path="/top-customers"
          element={
            <>
              <PageTitle breadcrumbs={dashboardBreadcrumbs}>
                Top Customers
              </PageTitle>
              <TopCustomers />
            </>
          }
        />
        <Route
          path="/top-products"
          element={
            <>
              <PageTitle breadcrumbs={dashboardBreadcrumbs}>
                Top Products
              </PageTitle>
              <TopProducts />
            </>
          }
        />
        <Route
          path="/top-sellers"
          element={
            <>
              <PageTitle breadcrumbs={dashboardBreadcrumbs}>
                Top Sellers
              </PageTitle>
              <TopSellers />
            </>
          }
        />
      </Route>
    </Routes>
  </>
);
export default DashboardIndex;
